import { render, staticRenderFns } from "./BalancePageMenuItem.vue?vue&type=template&id=6a11d559&scoped=true&"
import script from "./BalancePageMenuItem.vue?vue&type=script&lang=js&"
export * from "./BalancePageMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./BalancePageMenuItem.vue?vue&type=style&index=0&id=6a11d559&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a11d559",
  null
  
)

export default component.exports